var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0937 9.59369L9.09998 13.5874C8.22498 14.4624 6.78748 14.4624 5.90623 13.5874L1.91248 9.59369C1.03748 8.71869 1.03748 7.2812 1.91248 6.39995L5.90623 2.40619C6.78123 1.53119 8.21873 1.53119 9.09998 2.40619L13.0937 6.39995C13.9687 7.2812 13.9687 8.71869 13.0937 9.59369Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 4.40631L11.0938 11.5938",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 4.40631L3.90625 11.5938",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settings-active.a1c1d124e1a485ee59afbafb3eec482c.svg";
export { ForwardRef as ReactComponent };